"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M3 21h8V3H3zM21 3h-8v8h8zm-8 18h8v-8h-8z"
}), 'AutoAwesomeMosaicSharp');